var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.745 15.4648C58.406 14.188 57.7376 13.0226 56.8065 12.0855C55.8755 11.1483 54.7146 10.4722 53.44 10.1248C48.7625 8.8623 30 8.8623 30 8.8623C30 8.8623 11.2375 8.8623 6.5575 10.1248C5.28352 10.4728 4.12323 11.1491 3.19269 12.0863C2.26215 13.0234 1.59398 14.1884 1.255 15.4648C0 20.1748 0 29.9998 0 29.9998C0 29.9998 0 39.8248 1.255 44.5348C1.59396 45.8116 2.26244 46.977 3.19348 47.9141C4.12452 48.8513 5.28544 49.5275 6.56 49.8748C11.2375 51.1373 30 51.1373 30 51.1373C30 51.1373 48.7625 51.1373 53.4425 49.8748C54.7172 49.5277 55.8782 48.8516 56.8093 47.9144C57.7404 46.9772 58.4088 45.8117 58.7475 44.5348C60 39.8248 60 29.9998 60 29.9998C60 29.9998 60 20.1748 58.745 15.4648ZM23.8625 38.9198V21.0798L39.545 29.9998L23.8625 38.9198Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b8b3845ae7044117c2479df3a3c39bf0.svg";
export { ForwardRef as ReactComponent };